export default{
  "Video Compressor": "Video Sıkıştırıcı",
  "HitPaw Online Video Compressor": "HitPaw Çevrimiçi Video Sıkıştırıcı",
  "Best video compressor tool to reduce video file size online without losing quality.": "Kaliteyi kaybetmeden çevrimiçi video dosyası boyutunu azaltmak için en iyi video sıkıştırma aracı.",
  "Quality": "Kalite",
  "Small Size": "Küçük Boyut (%{{num}})",
  "High Quality": "Yüksek Kalite (%{{num}})",
  "Frame Rate": "Kare Hızı",
  "Resolution": "Çözünürlük",
  "Keep Resolution": "Çözünürlüğü Koru",
  "Format": "Biçim",
  "Compress": "Sıkıştırılmış",
  "Compressing": "Skıştırma",
  "Compress New": "Yeni Sıkıştır",
  "xx% reduction in size!": "boyutta %{{num}} azalma!",
  "Compressed successfully, your file is now xxMB.": "Başarıyla sıkıştırıldı, dosyanız artık <p> {{originalSize}}MB</p> <p>{{compressSize}}MB</p>.",
  "Compression Failed": "Sıkıştırma Başarısız",
};